<template>
  <div class="all-lb" style="display: flex" ref="tableRef">
    <div class="total-m">
      <div class="total-list">
        <div class="tab-list">
          <div class="tittle-right" style="display: flex" ref="deleteRef">
            <!-- <el-button class="" type="text" @click="readClick"
              >全部标为已读</el-button
            > -->
            <el-button class="delete" type="text" @click="deleteClick"
              >全部删除</el-button
            >
            <span class="button-r" @click="eoistolizeDialog = true">
              <img
                style="margin: -5px 0"
                src="../assets/img/rtaLogo/info.svg"
                alt="写私信"
              />
              写私信
            </span>
            <el-dialog
              title="写私信"
              class="eoistolize"
              :visible.sync="eoistolizeDialog"
              width="720px"
              :before-close="handleClose"
              append-to-body
            >
              <el-form
                :model="eoistolizForm"
                :rules="rules"
                ref="eoistolizForm"
                label-width="54px"
              >
                <el-form-item label="收信人" prop="name">
                  <el-select
                    v-model="eoistolizForm.name"
                    style="width: 100%"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="发送给…"
                    @change="userChange"
                  >
                    <el-option
                      v-for="item in eoistolizeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="主题" prop="subject">
                  <el-input
                    v-model="eoistolizForm.subject"
                    placeholder="请输入主题"
                  ></el-input>
                </el-form-item>
                <el-form-item class="textarea-item" prop="textarea">
                  <el-input
                    type="textarea"
                    placeholder="说点什么吧"
                    v-model="eoistolizForm.textarea"
                    maxlength="500"
                    show-word-limit
                    class="textarea"
                    style=" 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button
                  style="height: 32px"
                  @click="eoistolizeDialog = false"
                  class="bnt"
                  >取 消</el-button
                >
                <el-button
                  style="height: 32px"
                  type="primary"
                  @click="listSubmit('eoistolizForm')"
                  class="bnt"
                  >立即创建</el-button
                >
              </div>
            </el-dialog>
          </div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="收信箱" name="first">
              <div class="total-list-mine">
                <div class="leaderboard">
                  <div
                    class="top-leaderboard"
                    style="display: flex"
                    ref="tableRef"
                  >
                    <el-table :data="inboxData" border style="width: 100%">
                      <el-table-column type="index" label="" width="1000">
                        <template slot-scope="scope">
                          <div
                            class="top-n"
                            @mouseenter="toggleShow($event)"
                            @mouseleave="disShow($event)"
                          >
                            <div class="top-left">
                              <div class="user">
                                <div
                                  class="user-img"
                                  @click="userClick(scope.row.uuid)"
                                >
                                  <div
                                    style="display: flex"
                                    v-show="scope.row.isRead == false"
                                  >
                                    <div class="unreadClass"></div>
                                  </div>

                                  <img
                                    class="head-portrait"
                                    :src="scope.row.avatar"
                                    alt=""
                                  />
                                  <img class="vip" :src="imgUrl" alt="" />
                                </div>
                                <div class="user-name">
                                  <div class="user">
                                    <div class="usreName">
                                      {{ scope.row.messageName }}
                                    </div>
                                    <span class="letter">与你的私信</span>
                                    <div class="user-time">
                                      <span>{{ scope.row.sendTime }}</span>
                                    </div>
                                  </div>

                                  <div class="motto">
                                    <el-button
                                      type="text"
                                      @click="detailClick(scope.row.messageId)"
                                      >主题：{{ scope.row.subject }}</el-button
                                    >
                                    <!-- 点击主题跳转详情 -->
                                    <el-dialog
                                      :title="user"
                                      class="privaTetterDialog"
                                      :visible.sync="detailDialog"
                                      width="720px"
                                      :before-close="handleClose"
                                      append-to-body
                                    >
                                      <el-form
                                        :model="replayForm"
                                        :rules="replayRules"
                                        ref="replayForm"
                                        label-width="54px"
                                      >
                                        <el-form-item
                                          label="主题"
                                          prop="replyContent"
                                        >
                                          <el-input
                                            v-model="replayForm.replyContent"
                                          ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                          label="日期"
                                          prop="replyContent"
                                        >
                                          <el-input
                                            v-model="replayForm.replyTime"
                                          ></el-input>
                                        </el-form-item>
                                        <el-form-item class="textarea-item">
                                          <el-input
                                            disabled
                                            type="textarea"
                                            v-model="replayForm.replayLetter"
                                            maxlength="500"
                                            show-word-limit
                                            class="textarea"
                                            style=" 100%"
                                          >
                                          </el-input>
                                        </el-form-item>
                                      </el-form>
                                      <div slot="footer" class="dialog-footer">
                                        <el-button
                                          type="primary"
                                          @click="replayCl"
                                          >回复</el-button
                                        >
                                      </div>
                                      <!-- 嵌套回复私信 -->
                                      <el-dialog
                                        width="720px"
                                        :title="user"
                                        :visible.sync="replayClick"
                                        class="answerLetterDialog"
                                        :before-close="handleClose"
                                        append-to-body
                                      >
                                        <el-form
                                          :model="replayForm"
                                          :rules="replayRules"
                                          ref="replayForm"
                                          label-width="54px"
                                        >
                                          <el-form-item
                                            label="主题"
                                            prop="replyContent"
                                          >
                                            <el-input
                                              v-model="replayForm.replyL"
                                            ></el-input>
                                          </el-form-item>
                                          <el-form-item
                                            label="内容"
                                            prop="replayLetter"
                                            class="content-row"
                                          >
                                            <el-input
                                              type="textarea"
                                              style="resize: none"
                                              :rows="2"
                                              resize="none"
                                              :autosize="{
                                                minRows: 2,
                                                maxRows: 2,
                                              }"
                                              v-model="replayForm.replayLetter"
                                            ></el-input>
                                          </el-form-item>
                                          <el-form-item
                                            class="replyTextarea"
                                            prop="textarea"
                                          >
                                            <el-input
                                              type="textarea"
                                              placeholder="说点什么吧"
                                              v-model="replayForm.textarea"
                                              maxlength="500"
                                              show-word-limit
                                              class="textarea"
                                              style=" 100%"
                                            >
                                            </el-input>
                                          </el-form-item>
                                        </el-form>
                                        <div
                                          slot="footer"
                                          class="dialog-footer"
                                        >
                                          <el-button
                                            @click="replayReset('replayForm')"
                                            >取 消</el-button
                                          >
                                          <el-button
                                            type="primary"
                                            @click="submitForm('replayForm')"
                                            >发送</el-button
                                          >
                                        </div>
                                      </el-dialog>
                                    </el-dialog>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="delete" v-show="false">
                              <el-button
                                @click.native.prevent="
                                  deleteRow(scope.$index, inboxData)
                                "
                                type="text"
                                size="small"
                                ><img
                                  src="../assets/img/rtaLogo/delete.svg"
                                  alt=""
                              /></el-button>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="default-page" style="display: none" ref="nullRef">
                    <div class="default-entrance">
                      <img
                        src="../assets/img/rtaLogo/default-photo-te.svg"
                        alt=""
                      />
                      <span>你还没有收到新的私信</span>
                      <el-button @click="eoistolizeDialog = true"
                        >写私信</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="已发送" name="second">
              <div class="total-list-mine">
                <div class="leaderboard">
                  <div
                    class="top-leaderboard"
                    style="display: flex"
                    ref="ouboxTableRef"
                  >
                    <el-table :data="outboxData" border style="width: 100%">
                      <el-table-column type="index" label="" width="1000">
                        <template slot-scope="scope">
                          <div
                            class="top-n"
                            @mouseenter="toggleShow($event)"
                            @mouseleave="disShow($event)"
                          >
                            <div class="top-left">
                              <div class="user">
                                <div class="user-img" @click="userClick">
                                  <img
                                    class="head-portrait"
                                    :src="scope.row.avatar"
                                    alt=""
                                  />
                                  <img class="vip" :src="imgUrl" alt="" />
                                </div>
                                <div class="user-name">
                                  <div class="user" @click="userClick">
                                    <div class="usreName">
                                      {{ scope.row.messageName }}
                                    </div>
                                    <span class="letter">与你的私信</span>
                                    <div class="user-time">
                                      <span>{{ scope.row.sendTime }}</span>
                                    </div>
                                  </div>

                                  <div class="motto">
                                    <el-button
                                      type="text"
                                      @click="mottoClick(scope.row.messageId)"
                                      >主题：{{ scope.row.subject }}</el-button
                                    >
                                    <!-- 点击主题跳转详情 -->
                                    <el-dialog
                                      :title="toUser"
                                      class="privaTetterDialog"
                                      :visible.sync="outboxDialog"
                                      width="720px"
                                      :before-close="handleClose"
                                      append-to-body
                                    >
                                      <el-form
                                        :model="outboxForm"
                                        :rules="replayRules"
                                        ref="outboxForm"
                                        label-width="54px"
                                      >
                                        <el-form-item
                                          label="主题"
                                          prop="replyContent"
                                        >
                                          <el-input
                                            v-model="outboxForm.subject"
                                          ></el-input>
                                        </el-form-item>
                                        <el-form-item
                                          label="日期"
                                          prop="replyContent"
                                        >
                                          <el-input
                                            v-model="outboxForm.sendTime"
                                          ></el-input>
                                        </el-form-item>
                                        <el-form-item class="textarea-item">
                                          <el-input
                                            disabled
                                            type="textarea"
                                            v-model="outboxForm.content"
                                            maxlength="500"
                                            show-word-limit
                                            class="textarea"
                                            style=" 100%"
                                          >
                                          </el-input>
                                        </el-form-item>
                                      </el-form>
                                      <div slot="footer" class="dialog-footer">
                                        <el-button
                                          type="primary"
                                          @click="replays"
                                          >回复</el-button
                                        >
                                      </div>
                                      <!-- 嵌套回复私信 -->
                                      <el-dialog
                                        width="720px"
                                        :title="toUser"
                                        :visible.sync="replayClick"
                                        class="answerLetterDialog"
                                        :before-close="handleClose"
                                        append-to-body
                                      >
                                        <el-form
                                          :model="outboxForm"
                                          :rules="replayRules"
                                          ref="outboxForm"
                                          label-width="54px"
                                        >
                                          <el-form-item
                                            label="主题"
                                            prop="replyContent"
                                          >
                                            <el-input
                                              v-model="outboxForm.replyL"
                                            ></el-input>
                                          </el-form-item>
                                          <el-form-item
                                            label="内容"
                                            prop="replayLetter"
                                            class="content-row"
                                          >
                                            <el-input
                                              type="textarea"
                                              style="resize: none"
                                              :rows="2"
                                              resize="none"
                                              :autosize="{
                                                minRows: 2,
                                                maxRows: 2,
                                              }"
                                              v-model="outboxForm.content"
                                            ></el-input>
                                          </el-form-item>
                                          <el-form-item
                                            class="replyTextarea"
                                            prop="textarea"
                                          >
                                            <el-input
                                              type="textarea"
                                              placeholder="说点什么吧"
                                              v-model="outboxForm.textarea"
                                              maxlength="500"
                                              show-word-limit
                                              class="textarea"
                                              style=" 100%"
                                            >
                                            </el-input>
                                          </el-form-item>
                                        </el-form>
                                        <div
                                          slot="footer"
                                          class="dialog-footer"
                                        >
                                          <el-button
                                            @click="resetForm('outboxForm')"
                                            >取 消</el-button
                                          >
                                          <el-button
                                            type="primary"
                                            @click="outboxSubmit('outboxForm')"
                                            >发送</el-button
                                          >
                                        </div>
                                      </el-dialog>
                                    </el-dialog>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="delete" v-show="false">
                              <el-button
                                @click.native.prevent="
                                  deleteOutboxRow(scope.$index, outboxData)
                                "
                                type="text"
                                size="small"
                                ><img
                                  src="../assets/img/rtaLogo/delete.svg"
                                  alt=""
                              /></el-button>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div
                    class="default-page"
                    style="display: none"
                    ref="outboxRef"
                  >
                    <div class="default-entrance">
                      <img
                        src="../assets/img/rtaLogo/default-photo-te.svg"
                        alt=""
                      />
                      <span>你还没有收到新的私信</span>
                      <el-button @click="eoistolizeDialog = true"
                        >写私信</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="pagination" style="display: flex" ref="paginationRef">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageParams.currentPage"
        background
        layout="sizes, prev, pager, next"
        :page-count="pageParams.pageCount"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageParams.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserAsset } from '../api/User';
import {
  getMessageInbox,
  getMessageOutbox,
  getMessageInfoContent,
  getMessageSendInfo,
  getUsers,
  deleteMessageInbox,
  deleteMessageOutbox,
  deleteMessageInfo,
  getQuestionsSubmit,
} from '@/api/message.js';
export default {
  components: {},
  data() {
    return {
      accountId: '',
      inboxData: [],
      outboxData: [],
      ifDisplay: false,
      messageName: 'Eugenia Freeman',
      //写私信对话框
      eoistolizeDialog: false,
      eoistolizForm: {
        uuid: [],
        subject: '',
        textarea: '',
      },
      eoistolizeOptions: [],

      rules: {
        name: [{ required: true, message: '请填写收信人', trigger: 'change' }],
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        textarea: [
          { required: true, message: '请填写私信内容', trigger: 'blur' },
        ],
      },
      read: true,
      //标签页
      sub: '不要害怕把自己的弱项暴露给他人',
      activeName: 'first',
      //详情页对话框
      detailDialog: false,
      outboxDialog: false,
      replayClick: false,
      detailForm: {
        name: [],
        subject: '',
        textarea: '',
      },

      detailRules: {
        name: [{ required: true, message: '请填写收信人', trigger: 'change' }],
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
      },
      replayForm: {
        replyL: '',
        replyContent: '',
        replyTime: '',
        replayLetter: '',
        textarea: '',
      },
      replayRules: {
        textarea: [
          { required: true, message: '请填写回复内容', trigger: 'blur' },
        ],
      },
      infoForm: {
        subject: '',
        content: '',
        textarea: '',
      },
      outboxForm: {
        replyL: '',
        subject: '不要害怕把自己的弱项暴露给他人',
        sendTime: '2022-07-14 17:23',
        content:
          '将如影便克员级边百确快参联业但东里接流毛度调多接较那委器常头七照实火别一无老我电示斗共组济第其本红天战种革少解当级或造多何建增。战族百空写影程那构身种交育意直派还调行务青有离安革具太组精文较可指严统圆据济二说构真需点做马值省层油金青断。油构公革通器即心做叫名管放大列口年工支往小文百调克民克者己写界品使几系技效级极格场目广对风完真列身十这办意照没个比速县。调能有到已北元流量值斯务间日在都重表采中表新样包后角对商选个制周术长党争文列造着省手证且可',
        textarea: '',
      },

      user: '',
      toUser: '',
      display: false,
      aaaa: false,
      pageParams: {
        pageIndex: 1,
        pageSize: 10,
        total: 20,
        pageCount: 3,
      },
      sendTime: '',
      timeArr: [],
      uuid: '',
      tebName: 'first',
      isRead: true,
    };
  },
  created() {
    this.getInboxData();
    this.getUserData();
    // this.getOutboxData();
  },
  mounted() {},
  methods: {
    //获取收件箱全部数据
    async getInboxData() {
      this.inboxData = [];
      let params = {
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getMessageInbox(params);
      if (res.data.length == 0) {
        this.$refs.nullRef.style.display = 'flex';
        this.$refs.tableRef.style.display = 'none';
        this.$refs.deleteRef.style.display = 'none';
        this.$refs.paginationRef.style.display = 'none';
        //console.log(this.$refs.tableRef.style.display);
        // this.$refs.nullRef.style.display = 'flex';
      } else {
        this.$refs.tableRef.style.display = 'flex';
        this.$refs.deleteRef.style.display = 'flex';
        this.$refs.nullRef.style.display = 'none';
        this.$refs.paginationRef.style.display = 'flex';
        let inboxs = res.data;
        this.pageParams.pageCount = res.pageCount;
        inboxs.forEach((item) => {
          this.timeArr = this.dateTypeFormat(
            'mm-dd HH:MM',
            new Date(item.sendTime)
          );
          const inboxObj = {
            messageName: item.from.name,
            subject: item.subject,
            sendTime: this.timeArr,
            avatar: item.from.avatar,
            vipName: item.from.vipName,
            isRead: item.isRead,
            messageId: item.messageId,
            uuid: item.from.uuid,
          };
          this.inboxData.push(inboxObj);
          this.inboxData.forEach((item) => {
            var text = item.vipName;
            if (text == null) {
              this.imgUrl = '';
            } else {
              switch (text) {
                case '高级会员V1':
                  this.imgUrl = require('@/assets/img/rtaLogo/V1.svg');
                  break;
                case '高级会员V2':
                  this.imgUrl = require('@/assets/img/rtaLogo/V2.svg');
                  break;
                case '超级会员':
                  this.imgUrl = require('@/assets/img/rtaLogo/SVIP.svg');
                  break;
              }
            }
          });
        });
      }
    },
    //获取已发送全部数据
    async getOutboxData() {
      this.outboxData = [];
      let params = {
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getMessageOutbox(params);
      if (res.data.length == 0) {
        this.$refs.ouboxTableRef.style.display = 'none';
        this.$refs.deleteRef.style.display = 'none';
        this.$refs.paginationRef.style.display = 'none';
        this.$refs.outboxRef.style.display = 'flex';
        //console.log(this.$refs.tableRef.style.display);
        // this.$refs.nullRef.style.display = 'flex';
      } else {
        this.$refs.ouboxTableRef.style.display = 'flex';
        this.$refs.deleteRef.style.display = 'flex';
        this.$refs.paginationRef.style.display = 'flex';
        this.$refs.outboxRef.style.display = 'none';
        let outboxs = res.data;
        this.pageParams.pageCount = res.pageCount;
        outboxs.forEach((item) => {
          this.timeArr = this.dateTypeFormat(
            'mm-dd HH:MM',
            new Date(item.sendTime)
          );
          const inboxObj = {
            messageName: item.to.name,
            subject: item.subject,
            sendTime: this.timeArr,
            avatar: item.to.avatar,
            vipName: item.to.vipName,
            messageId: item.messageId,
          };
          this.outboxData.push(inboxObj);
          this.outboxData.forEach((item) => {
            var text = item.vipName;
            if (text == null) {
              this.imgUrl = '';
            } else {
              switch (text) {
                case '高级会员V1':
                  this.imgUrl = require('@/assets/img/rtaLogo/V1.svg');
                  break;
                case '高级会员V2':
                  this.imgUrl = require('@/assets/img/rtaLogo/V2.svg');
                  break;
                case '超级会员':
                  this.imgUrl = require('@/assets/img/rtaLogo/SVIP.svg');
                  break;
              }
            }
          });
          //点击主题内容

          this.outboxForm.subject = item.subject;
          this.outboxForm.sendTime = this.dateTypeFormat(
            'YY-mm-dd HH:MM',
            new Date(item.sendTime)
          );
          this.outboxForm.content = item.content;
        });
      }
    },

    // 每页显示的记录数切换事件
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.inboxData = [];
      this.outboxData = [];
      if (this.activeName == 'second') {
        thia.getOutboxData();
      } else {
        this.getInboxData();
      }

      //console.log('每页及记录-->', this.pageParams.pageSize);
    },
    // 切换页码事件
    handleCurrentChange(val) {
      //console.log(val)
      this.pageParams.pageIndex = val;
      this.inboxData = [];
      this.outboxData = [];
      if (this.activeName == 'second') {
        this.getOutboxData();
      } else {
        this.getInboxData();
      }
    },
    handleClick() {
      this.outboxData = [];
      this.inboxData = [];
      this.pageParams.pageIndex = 1;
      this.pageParams.pageSize = 10;
      if (this.activeName == 'second') {
        this.getOutboxData();
      } else {
        this.getInboxData();
      }
    },
    //删除收件箱私信
    async deleteRow(index, rows) {
      let deleteObj = {
        messageId: rows[index].messageId,
      };
      const { data: res } = await deleteMessageInfo(deleteObj);
      rows.splice(index, 1);
      this.getInboxData();
    },
    //删除已发送私信
    async deleteOutboxRow(index, rows) {
      let deleteObj = {
        messageId: rows[index].messageId,
      };
      const { data: res } = await deleteMessageInfo(deleteObj);
      rows.splice(index, 1);
      this.getOutboxData();
    },
    //清空收件箱跟发件箱
    deleteClick() {
      if (this.tebName == 'first') {
        this.$confirm('', '确定要清空所有信件？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          customClass: 'Teletter-confirm',
        })
          .then(async () => {
            const { data: res } = await deleteMessageInbox();
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.msg,
              });
              this.getInboxData();
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      } else {
        this.$confirm('', '确定要清空所有信件？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          customClass: 'Teletter-confirm',
        })
          .then(async () => {
            const { data: res } = await deleteMessageOutbox();
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: res.msg,
              });
              this.getOutboxData();
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      }
    },
    //鼠标进入（进入子元素不触发）
    toggleShow($event) {
      this.ifDisplay = true;
      $event.target.children[1].style = 'display:block';
    },
    //鼠标离开（离开子元素不触发）
    disShow($event) {
      this.ifDisplay = false;
      $event.target.children[1].style = 'display:none';
    },
    //对话框确定关闭
    handleClose(done) {
      this.$confirm('', '确认关闭？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: '',
        customClass: 'Teletter-confirm',
      })
        .then((_) => {
          done();
          this.eoistolizForm.name = [];
          this.eoistolizForm.subject = '';
          this.eoistolizForm.textarea = '';
        })
        .catch((_) => {});
    },
    //写私信
    async listSubmit(formName) {
      let sendMessageObj = {
        uuid: this.eoistolizForm.name,
        subject: this.eoistolizForm.subject,
        content: this.eoistolizForm.textarea,
      };
      // console.log('发送对象：', sendMessageObj);
      const { data: res } = await getMessageSendInfo(sendMessageObj);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message(res.msg);
          this.getInboxData();
          this.getOutboxData();
          this.eoistolizeDialog = false;
          this.eoistolizForm.name = [];
          this.eoistolizForm.subject = '';
          this.eoistolizForm.textarea = '';
        }
      });
    },
    //收件箱回复私信
    async submitForm(formName) {
      let sendMessageObj = {
        uuid: this.uuid,
        subject: this.replayForm.replyContent,
        content: this.replayForm.textarea,
      };
      const { data: res } = await getMessageSendInfo(sendMessageObj);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message(res.msg);
          this.replayClick = false;
          this.replayForm.replyContent = '';
          this.replayForm.replayLetter = '';
          this.replayForm.textarea = '';
        }
      });
    },
    replayCl() {
      this.replayClick = true;
      this.detailDialog = false;
    },
    replayReset(formName) {
      this.replayClick = false;
      this.$refs[formName].resetFields();
    },
    resetForm(formName) {
      this.detailDialog = false;
      this.replayClick = false;
      this.$refs[formName].resetFields();
    },
    //已发送回复私信
    async outboxSubmit(formName) {
      let sendMessageObj = {
        uuid: this.uuid,
        subject: this.outboxForm.subject,
        content: this.outboxForm.textarea,
      };
      //console.log("发送对象：",sendMessageObj);
      const { data: res } = await getMessageSendInfo(sendMessageObj);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message(res.msg);
          this.replayClick = false;
          this.outboxForm.subject = '';
          this.outboxForm.textarea = '';
          this.outboxForm.content = '';
        }
      });
      //console.log("返回内容：",res);
    },
    //全部标记已读按钮
    readClick() {
      //this.$refs.readRef.style.display = 'none';
      this.read = false;
    },
    //头像跳转用户详情
    async userClick(id) {
      let params = {
        targetUUID: id,
        accountId: this.accountId,
      };
      const { data: res } = await getUserAsset(params);

      if (res.code == 10001 || res.code == 10006) {
        this.$message({
          message: res.msg,
          type: 'warning',
        });
        return;
      }
      this.$router.replace({
        path: '/User',
        query: { targetUUID: id, accountId: this.accountId },
      });
    },
    //发私信收信人事件
    userChange(value) {
      this.eoistolizForm.name = value;
      //console.log('111', this.eoistolizForm.name);
    },
    // 根据私信ID获取私信内容
    async findByIdMessageInfo(id) {
      const { data: res } = await getMessageInfoContent({
        messageId: id,
      });
      //收件箱
      this.user = '与' + res.data.form.name + '私信';
      this.replayForm.replyL = '回复 ' + res.data.subject + ' 的私信';
      this.replayForm.replyContent = res.data.subject;
      this.replayForm.replyTime = this.dateTypeFormat(
        'YY-mm-dd HH:MM',
        new Date(res.data.sendTime)
      );
      this.replayForm.replayLetter = res.data.content;
      this.uuid = res.data.form.uuid;
      // console.log(this.uuid);

      //已发送
      this.toUser = '与' + res.data.to + '私信';
      this.outboxForm.replyL = '回复 ' + res.data.subject + ' 私信';
      this.outboxForm.subject = res.data.subject;
      this.outboxForm.sendTime = this.dateTypeFormat(
        'YY-mm-dd HH:MM',
        new Date(res.data.sendTime)
      );
      this.outboxForm.content = res.data.content;
    },
    //获取写私信所有用户
    async getUserData() {
      const { data: res } = await getUsers();
      let users = res.data;
      // console.log('用户信息', users);
      users.forEach((item) => {
        const userObj = {
          value: item.uuid,
          label: item.name,
        };
        this.eoistolizeOptions.push(userObj);
        // console.log(this.eoistolizeOptions);
      });
    },

    // 点击私信列表获取详细信息
    detailClick(id) {
      this.user = '';
      this.replayForm.replyContent = '';
      this.replayForm.replyTime = '';
      this.replayForm.replayLetter = '';
      this.findByIdMessageInfo(id);
      this.detailDialog = true;
    },
    replays() {
      this.outboxDialog = false;
      this.replayClick = true;
    },
    //已发送写私信私信
    mottoClick(id) {
      this.toUser = '';
      this.outboxForm.subject = '';
      this.outboxForm.sendTime = '';
      this.outboxForm.content = '';
      this.outboxDialog = true;
      this.findByIdMessageInfo(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.all-lb {
  width: 1200px;

  //text-align: center;
  display: flex !important;
  flex-direction: column !important;
  margin: 0 auto !important;
  .total-m {
    margin: 40px 100px !important;
    .total-list {
      margin: 0 !important;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      background: transparent;
      .tab-list {
        position: relative;
        .tittle-right {
          width: 170px;
          position: absolute;
          right: -3px;
          top: 27px !important;
          //border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
          .el-button {
            height: 40px;
            padding: 0 !important;
            margin: 0 24px 0 0;
            font-size: 16px !important;
            font-family: MicrosoftYaHei !important;
            display: flex;
            span {
              color: rgba(209, 212, 220, 0.7) !important;
              height: 24px !important;
              line-height: 24px !important;
              display: flex !important;
            }
          }
          .delete {
            margin: 0 20px 0 0 !important;
            span {
            }
          }
          .el-button--text {
            color: rgba(209, 212, 220, 0.7) !important;
          }
          span {
            color: #d1d4dc !important;
            margin: 0 !important;
            img {
              margin-top: -6px !important;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" >
.all-lb {
  .el-tabs--card {
    background: transparent !important;
    .el-tabs__header {
      border-bottom: transparent !important;
      width: 700px;
      margin: 0;
      .el-tabs__nav-wrap {
        .el-tabs__nav-scroll {
          .el-tabs__nav {
            border: none;
            .el-tabs__item {
              padding: 0 40px 0 0;
              height: 72px;
              box-sizing: border-box;
              line-height: 72px;
              font-weight: 500;
              color: #d1d4dc;
              border: none;
              font-size: 18px;
              font-family: MicrosoftYaHei;
            }
            .el-tabs__item.is-active {
              color: #edbd88 !important;
            }
          }
        }
      }
    }
    .el-tabs__content {
      .el-tab-pane {
        .total-list-mine {
          .leaderboard {
            width: 100%;
            height: 100%;
            border-radius: 11px;
            .top-leaderboard {
              width: 100%;
              .el-table__body tr:hover > td {
                background: rgba(255, 255, 255, 0.1) !important;
                color: #33353e;
              }
              .el-table {
                border-radius: 8px;
                tr {
                  background: #3e4048 !important;
                  .el-table__cell {
                    padding: 0;
                    .cell {
                      padding: 0;
                      .top-n {
                        width: 100%;
                        height: 96px;
                        display: flex;
                        justify-content: space-between;
                        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                        .top-left {
                          display: flex;
                          width: 934px;
                          .user {
                            width: 100%;
                            display: flex;
                            .user-img {
                              cursor: pointer;
                              margin: 29px 0px 27px 40px;
                              position: relative;
                              .unreadClass {
                                width: 10px;
                                height: 10px;
                                background: #a61d24;
                                border: 1px solid #ffffff;
                                border-radius: 10px;
                                position: absolute;
                                z-index: 1000;
                                right: 0;
                                margin-right: -1px;
                              }
                              .readClass {
                                display: none;
                              }
                              .head-portrait {
                                width: 40px;
                                height: 40px;
                              }
                              .vip {
                                width: 30px;
                                height: 13px;
                                position: absolute;
                                top: 27px;
                                right: 6px;
                              }
                            }
                            .user-name {
                              cursor: pointer;
                              margin: 27px 0 27px 16px;
                              display: flex;
                              flex-direction: column;
                              width: 100%;
                              .user {
                                .usreName {
                                  width: fit-content !important;
                                  // white-space: nowrap !important;
                                  // overflow: hidden !important;
                                  // text-overflow: ellipsis !important;
                                  height: 20px;
                                  font-size: 14px;
                                  font-family: Roboto-Medium, Roboto;
                                  font-weight: 500;
                                  color: #d1d4dc;
                                  line-height: 20px;
                                }
                                span {
                                  width: 109px;
                                  height: 20px;
                                  font-size: 14px;
                                  font-family: Roboto-Medium, Roboto;
                                  font-weight: 500;
                                  color: #d1d4dc;
                                  line-height: 20px;
                                }
                                .letter {
                                  margin-left: 20px;
                                  width: 70px;
                                  height: 20px;
                                  font-size: 14px;
                                  font-family: PingFangSC-Regular, PingFang SC;
                                  font-weight: 400;
                                  color: rgba(255, 255, 255, 0.7);
                                  line-height: 20px;
                                }
                                .user-time {
                                  margin: 0 0 0 20px;
                                  span {
                                    width: 74px;
                                    height: 20px;
                                    font-size: 14px;
                                    font-family: Roboto-Regular, Roboto;
                                    font-weight: 400;
                                    color: #d1d4dc;
                                    line-height: 20px;
                                  }
                                }
                              }

                              .motto {
                                margin-top: 4px;
                                width: 720px;
                                height: 20px;
                                line-height: 16px;
                                .el-button {
                                  width: 720px;
                                  text-align: left;
                                  margin: 0;
                                  padding: 0;
                                  font-size: 14px;
                                  font-family: Roboto-Regular, Roboto;
                                  font-weight: 400;
                                  color: #d1d4dc;
                                  span {
                                    width: 720px !important;
                                    white-space: nowrap !important;
                                    overflow: hidden !important;
                                    text-overflow: ellipsis !important;
                                  }
                                }
                              }
                            }
                          }
                        }
                        .delete {
                          margin-right: 40px;
                          .el-button {
                            padding: 0 !important;
                            img {
                              margin: 36px 0;
                            }
                          }
                        }

                        .price {
                          font-size: 24px;
                          font-family: Roboto-BoldItalic, Roboto;
                          font-weight: normal;
                          color: #d1d4dc;
                          line-height: 28px;
                          margin: 34px 64px 34px 511px;
                          display: flex;
                          font-style: italic;
                          span {
                            font-family: Roboto-BoldItalic, Roboto;
                          }
                        }
                      }
                    }
                  }
                }
                .el-table__header-wrapper {
                  display: none;
                }
                .el-table__body-wrapper {
                  border-radius: 8px !important;
                  background: rgba(255, 255, 255, 0.1) !important;
                  .el-table__empty-block {
                    display: none;
                  }
                }
              }
              .top-n {
                height: 96px;
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                .top-left {
                  display: flex;
                  width: 934px;
                  .user {
                    display: flex;
                    .user-img {
                      cursor: pointer;
                      margin: 29px 0px 27px 40px;
                      position: relative;
                      .unreadClass {
                        width: 10px;
                        height: 10px;
                        background: #a61d24;
                        border: 1px solid #ffffff;
                        border-radius: 10px;
                        position: absolute;
                        z-index: 1000;
                        right: 0;
                        margin-right: -1px;
                      }
                      .readClass {
                        display: none;
                      }
                      .head-portrait {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                      }
                      .vip {
                        width: 30px;
                        height: 13px;
                        position: absolute;
                        top: 27px;
                        right: 6px;
                      }
                    }
                    .user-name {
                      cursor: pointer;
                      margin: 27px 0 27px 16px;
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      .user {
                        width: 100%;
                        .usreName {
                          width: fit-content !important;
                          // white-space: nowrap !important;
                          // overflow: hidden !important;
                          // text-overflow: ellipsis !important;
                          height: 20px;
                          font-size: 14px;
                          font-family: Roboto-Medium, Roboto;
                          font-weight: 500;
                          color: #d1d4dc;
                          line-height: 20px;
                        }
                        span {
                          height: 20px;
                          font-size: 14px;
                          font-family: Roboto-Medium, Roboto;
                          font-weight: 500;
                          color: #d1d4dc;
                          line-height: 20px;
                        }
                        .letter {
                          margin-left: 20px;
                          width: 70px;
                          height: 20px;
                          font-size: 14px;
                          font-family: PingFangSC-Regular, PingFang SC;
                          font-weight: 400;
                          color: rgba(255, 255, 255, 0.7);
                          line-height: 20px;
                        }
                        .user-time {
                          margin: 0 0 0 20px;
                          span {
                            width: 74px;
                            height: 20px;
                            font-size: 14px;
                            font-family: Roboto-Regular, Roboto;
                            font-weight: 400;
                            color: #d1d4dc;
                            line-height: 20px;
                          }
                        }
                      }

                      .motto {
                        margin-top: 4px;
                        width: 720px;
                        height: 20px;

                        line-height: 16px;
                        .el-button {
                          width: 720px;
                          text-align: left;
                          margin: 0;
                          padding: 0;
                          font-size: 14px;
                          font-family: Roboto-Regular, Roboto;
                          font-weight: 400;
                          color: #d1d4dc;
                          span {
                            width: 720px !important;
                            white-space: nowrap !important;
                            overflow: hidden !important;
                            text-overflow: ellipsis !important;
                          }
                        }
                      }
                    }
                  }
                }
                .delete {
                  margin-right: 40px;
                  .el-button {
                    padding: 0 !important;
                    img {
                      margin: 36px 0;
                    }
                  }
                }

                .price {
                  font-size: 24px;
                  font-family: Roboto-BoldItalic, Roboto;
                  font-weight: normal;
                  color: #d1d4dc;
                  line-height: 28px;
                  margin: 34px 64px 34px 511px;
                  display: flex;
                  font-style: italic;
                  span {
                    font-family: Roboto-BoldItalic, Roboto;
                  }
                }
              }
              .top-n:hover {
                background: rgba(255, 255, 255, 0.1);
              }
              .top-n:hover .delete {
                display: block;
              }
            }
            .default-page {
              margin: 65px 100px;
              text-align: center;
              margin: 0 auto;
              background: rgba(255, 255, 255, 0.1) !important;
              border-radius: 8px;
              .default-entrance {
                margin: 148px 340px;
                display: flex;
                flex-direction: column;
                img {
                  width: 320px;
                  height: 220px;
                }
                span {
                  width: 320px;
                  margin-top: 32px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc;
                  line-height: 19px;
                }
                .el-button {
                  width: 320px;
                  height: 40px;
                  margin-top: 40px;
                  background: #edbd88;
                  border-radius: 4px;
                  padding: 0;
                  border: none;
                  span {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #33353e;
                  }
                }
                .el-button:active {
                  color: #33353e;
                }
                .el-button:focus,
                .el-button:hover {
                  color: #33353e;
                }
              }
            }
          }
        }
      }
    }
  }
}

.delete {
}

.el-message-box__wrapper {
  position: fixed;
  top: 0;
  bottom: 160px !important;
  left: 0;
  right: 550px;
  //text-align: right;
  .Teletter-confirm {
    width: 384px;
    height: 108px !important;
    background: rgba(51, 53, 62, 1);
    border: none;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
      0px 6px 16px 0px rgba(22, 23, 28, 0.32),
      0px 3px 6px -4px rgba(51, 53, 62, 0.48);
    border-radius: 4px;
    padding-bottom: 0 !important;
    .el-message-box__header {
      padding: 16px 26px 25px 22px !important;
      height: 26px;
      .el-message-box__title {
        width: 320px !important;
        span {
          width: 64px;
          height: 24px;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 0.85);
          line-height: 24px;
        }
      }
      .el-message-box__headerbtn {
        top: 26px !important;
        right: 26px !important;
        .el-message-box__close {
        }
      }
    }
    .el-message-box__content {
      padding: 0 15px;
      .el-message-box__container {
        .el-message-box__message {
          p {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.65);
            line-height: 22px;
          }
        }
      }
    }
    .el-message-box__btns {
      height: 24px !important;
      padding: 0 26px 16px 15px !important;
      .el-button {
        width: 49px;
        height: 24px;
        border-radius: 2px;
        background: #33353e;
        border: 1px solid rgba(255, 255, 255, 0.2);
        span {
          font-size: 13px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 0.65);
        }
      }
      .el-button--primary {
        background: #edbd88;
        span {
          color: #33353e;
        }
      }
      .el-button--small {
        padding: 0;
      }
    }
  }
}
.pagination {
  margin-top: 0 !important;
  justify-content: center;
  text-align: center;
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    margin: 0 5px;
    background-color: rgba(61, 63, 72, 1) !important;
    color: #d1d4dc;
    min-width: 32px;
    min-height: 32px;
    border-radius: 2px;
  }
  .el-pagination {
    .el-pagination__sizes {
      .el-select {
        .el-input {
          .el-input__inner {
            height: 32px;
            border: none !important;
            background-color: rgba(61, 63, 72, 1) !important;
            color: #d1d4dc;
          }
        }
      }
    }
    .el-pager {
      li {
        padding: 4px 4px;
      }
    }
    .el-pager li:not(.disabled):hover {
      color: rgba(51, 53, 62, 1) !important;
      background: #edbd88 !important;
    }
    .el-pager li:not(.disabled).active {
      color: rgba(51, 53, 62, 1) !important;
      background: #edbd88 !important;
    }
  }
}
.eoistolize {
  .el-dialog {
    height: 612px;
    background: #33353e !important;
    border-radius: 8px;
    .el-dialog__header {
      height: 70px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .el-dialog__title {
        line-height: 71px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        margin-left: 20px;
      }
    }
    .el-dialog__body {
      //   height: 100%;
      margin: 35px 20px 16px 20px;
      .el-form {
        .el-form-item {
          margin-bottom: 32px;
          .el-form-item__label {
            height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
            text-align: justify;
          }
          .el-form-item__label::after {
            content: ' ';
            width: 100%;
            display: inline-block;
          }
          .el-form-item__content {
            .el-select {
              .el-select__tags {
                .el-select__input {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc !important;
                }
              }
              .el-input {
                .el-input__inner {
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                }
                .el-input__suffix {
                  display: none;
                }
              }
            }
            .el-input {
              .el-input__inner {
                background: rgba(255, 255, 255, 0.1) !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
                border: none;
              }
            }
            .textarea {
              height: 263px !important;
              .el-input__inner {
                height: 206px;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-input__count {
                    // display: inline-flex;
                    // align-items: flex-end;
                    .el-input__count-inner {
                      background: transparent;
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #d1d4dc;
                      padding: 16px 16px;
                    }
                  }
                }
              }
            }
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 263px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                max-height: 263px;
                min-height: 263px !important;
                padding: 12px 16px 16px 16px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        // .textarea-item{
        //     .el-form-item__content{
        //         //margin-left: 0 !important;
        //     }
        // }
      }
    }
    .el-dialog__footer {
      padding: 8px 20px 20px;
      .dialog-footer {
        .bnt {
          height: 32px !important;
        }
        .el-button {
          line-height: 32px !important;
          width: 72px;
          height: 32px !important;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(51, 53, 62, 1);
          margin: 0 0 0 12px !important;
          padding: 0 !important;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
          }
        }
        .el-button--primary {
          background: #edbd88 !important;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
      }
    }
  }
}
.privaTetterDialog {
  .el-dialog {
    //height: 100% !important;
    background: #33353e !important;
    border-radius: 8px;
    -webkit-box-shadow: none !important;
    .el-dialog__header {
      height: 70px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .el-dialog__title {
        line-height: 71px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        margin-left: 20px;
      }
    }
    .el-dialog__body {
      height: 421px;
      margin: 35px 20px 0 20px;
      //私信详情
      .el-form {
        height: 421px;
        .el-form-item {
          margin-bottom: 12px !important;
          .el-form-item__label {
            height: 20px !important;
            line-height: 20px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: rgba(209, 212, 220, 0.7);
            text-align: justify;
          }
          .el-form-item__label::after {
            content: ' ';
            width: 100%;
            display: inline-block;
          }
          .el-form-item__content {
            height: 20px !important;
            line-height: 20px !important;
            .el-select {
              .el-select__tags {
                .el-select__input {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc !important;
                }
              }
              .el-input {
                .el-input__inner {
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                }
                .el-input__suffix {
                  display: none;
                }
              }
            }
            .el-input {
              .el-input__inner {
                height: 20px !important;
                line-height: 20px;
                background: none !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                border: none;
              }
            }
            // .textarea {
            //   height: 330px !important;
            //   .el-input__inner {
            //     height: 330px !important;
            //     overflow-y: auto;
            //     border: none;
            //     background: rgba(255, 255, 255, 0.1);
            //     border-radius: 4px;
            //   }
            //   .el-input__suffix {
            //     .el-input__suffix-inner {
            //       .el-input__count {
            //         // display: inline-flex;
            //         // align-items: flex-end;
            //         .el-input__count-inner {
            //           background: transparent;
            //           font-size: 14px;
            //           font-family: PingFangSC-Regular, PingFang SC;
            //           font-weight: 400;
            //           color: #d1d4dc;
            //           padding: 16px 16px;
            //         }
            //       }
            //     }
            //   }
            // }
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 330px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                max-height: 330px;
                min-height: 330px !important;
                padding: 12px 16px 16px 16px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .content-row {
          height: 46px !important;
          line-height: 46px !important;
          margin-bottom: 24px !important;
          .el-form-item__content {
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 46px !important;
                overflow-y: auto;
                border: none;
                background: none;
                border-radius: 4px;
                max-height: 46px;
                min-height: 46px !important;
                padding: 0 12px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden; //溢出内容隐藏
                text-overflow: ellipsis; //文本溢出部分用省略号表示
                display: -webkit-box; //特别显示模式
                -webkit-line-clamp: 2; //行数
                line-clamp: 2;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .textarea-item {
          margin: 24px 0 0 0 !important;
          .el-form-item__content {
            height: 330px !important;
          }
        }
        // .replyTextarea {
        //   margin-bottom: 0 !important;
        //   height: 314px !important;
        //   .el-form-item__content {
        //     height: 314px !important;
        //     .el-textarea {
        //       height: 314px !important;
        //       .el-textarea__inner {
        //         resize: none;
        //         height: 314px !important;
        //         overflow-y: auto;
        //         border: none;
        //         background: rgba(255, 255, 255, 0.1);
        //         border-radius: 4px;
        //         max-height: 314px;
        //         min-height: 314px !important;
        //         padding: 12px 16px 16px 16px;
        //         font-size: 14px;
        //         font-family: MicrosoftYaHei;
        //         color: rgba(209, 212, 220, 1);
        //       }
        //       .el-input__count {
        //         background: transparent;
        //         font-size: 14px;
        //         font-family: PingFangSC-Regular, PingFang SC;
        //         font-weight: 400;
        //         color: #d1d4dc;
        //       }
        //     }
        //   }
        // }
      }
    }
    .el-dialog__footer {
      padding: 24px 20px 32px;
      .dialog-footer {
        .el-button {
          line-height: 32px !important;
          width: 72px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(51, 53, 62, 1);
          margin: 0 0 0 12px !important;
          padding: 0 !important;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
          }
        }
        .el-button--primary {
          background: #edbd88 !important;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
      }
    }
  }
}
.answerLetterDialog {
  .el-dialog {
    //height: 100% !important;
    background: #33353e !important;
    border-radius: 8px;
    -webkit-box-shadow: none !important;
    .el-dialog__header {
      height: 70px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .el-dialog__title {
        line-height: 71px;
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        margin-left: 20px;
      }
    }
    .el-dialog__body {
      height: 421px;
      margin: 35px 20px 0 20px;
      //私信详情
      .el-form {
        height: 421px;
        .el-form-item {
          margin-bottom: 12px !important;
          .el-form-item__label {
            height: 20px !important;
            line-height: 20px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: rgba(209, 212, 220, 0.7);
            text-align: justify;
          }
          .el-form-item__label::after {
            content: ' ';
            width: 100%;
            display: inline-block;
          }
          .el-form-item__content {
            height: 20px !important;
            line-height: 20px !important;
            .el-select {
              .el-select__tags {
                .el-select__input {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc !important;
                }
              }
              .el-input {
                .el-input__inner {
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                }
                .el-input__suffix {
                  display: none;
                }
              }
            }
            .el-input {
              .el-input__inner {
                height: 20px !important;
                line-height: 20px;
                background: none !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                border: none;
              }
            }
            // .textarea {
            //   height: 330px !important;
            //   .el-input__inner {
            //     height: 330px !important;
            //     overflow-y: auto;
            //     border: none;
            //     background: rgba(255, 255, 255, 0.1);
            //     border-radius: 4px;
            //   }
            //   .el-input__suffix {
            //     .el-input__suffix-inner {
            //       .el-input__count {
            //         // display: inline-flex;
            //         // align-items: flex-end;
            //         .el-input__count-inner {
            //           background: transparent;
            //           font-size: 14px;
            //           font-family: PingFangSC-Regular, PingFang SC;
            //           font-weight: 400;
            //           color: #d1d4dc;
            //           padding: 16px 16px;
            //         }
            //       }
            //     }
            //   }
            // }
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 330px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                max-height: 330px;
                min-height: 330px !important;
                padding: 12px 16px 16px 16px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .content-row {
          height: 46px !important;
          line-height: 46px !important;
          margin-bottom: 24px !important;
          .el-form-item__content {
            .el-textarea {
              .el-textarea__inner {
                resize: none;
                height: 46px !important;
                overflow-y: auto;
                border: none;
                background: none;
                border-radius: 4px;
                max-height: 46px;
                min-height: 46px !important;
                padding: 0 12px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden; //溢出内容隐藏
                text-overflow: ellipsis; //文本溢出部分用省略号表示
                display: -webkit-box; //特别显示模式
                -webkit-line-clamp: 2; //行数
                line-clamp: 2;
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
        .textarea-item {
          margin: 24px 0 0 0 !important;
          .el-form-item__content {
            height: 330px !important;
          }
        }
        .replyTextarea {
          margin-bottom: 0 !important;
          height: 314px !important;
          .el-form-item__content {
            height: 314px !important;
            .el-textarea {
              height: 314px !important;
              .el-textarea__inner {
                resize: none;
                height: 314px !important;
                overflow-y: auto;
                border: none;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                max-height: 314px;
                min-height: 314px !important;
                padding: 12px 16px 16px 16px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
              }
              .el-input__count {
                background: transparent;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #d1d4dc;
              }
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 24px 20px 32px;
      .dialog-footer {
        .el-button {
          line-height: 32px !important;
          width: 72px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(51, 53, 62, 1);
          margin: 0 0 0 12px !important;
          padding: 0 !important;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
          }
        }
        .el-button--primary {
          background: #edbd88 !important;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
      }
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  font-size: 14px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #d1d4dc;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px 0px 0px 4px;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  font-size: 14px;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: #d1d4dc;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px 0px 0px 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/PrivaTeLetter.vue